import Slideshow from 'picnic/slideshow/views/Slideshow';
export default Slideshow;
